import { defineDirective, ITypedStock } from "../omnia"
import { IMmExport } from "../types"
import { StockVm } from "../vm/stockVm"
import { createStockVm } from "../vm/utils"

export function createStockAmount(): ng.IDirective {

    return defineDirective(StocksAmountCtrl, "app/stocks/amount/amount.html", {
        stock: "=",
        editMode: "=",
        exports: "="
    })

}

export function createStockAmountEdit(): ng.IDirective {

    return defineDirective(StocksAmountCtrl, "app/stocks/amount/amount-edit.html", {
        stock: "=",
        editMode: "=",
        duplicate: "=",
        exports: "="
    })

}


export class StocksAmountCtrl {

    static $inject = ["$scope"]

    private _vm: StockVm
    private _stock: any

    private editMode: boolean
    private duplicate: boolean

    private _exports: IMmExport[]

    constructor(private $scope: ng.IScope) {
    }

    get hasProduct(): boolean {
        return this._vm.hasProduct()
    }

    get exports(): IMmExport[] {
        return this._exports
    }

    set exports(value: IMmExport[]) {
        this._exports = value

        if (value && this._vm) {
            this._vm.setExports(this._exports)
        }
    }

    get stock(): any {
        return this._stock
    }

    set stock(value: any) {

        this._stock = value

        if (value) {

            if (value instanceof StockVm) {
                this._vm = <StockVm>value
            }
            else {
                this._vm = createStockVm(<ITypedStock>value)
            }

            if (this._exports) {
                this._vm.setExports(this._exports)
            }

        }

    }

    hasStock(): boolean {
        return (this._vm && (this._vm.getAvailableAmount() > 0))
    }

    getBalance() {
        return this._vm.getBalance()
    }

    getUnits() {
        return this._vm?.getUnits()
    }

    get availableAmount() {
        return this._vm?.getAvailableAmount()
    }

    set availableAmount(value: number) {
        if (this._vm && this.editMode) {
            this._vm.stock.TotalAmount = value
        }
    }

    getExportedAmount() {
        return this._vm?.getExportedAmount()
    }

}
